import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Markdown } from '@huggg/react-components';

import styles from './types.module.scss';

const isMarkdown = ({ type }) =>
  type && type.toLowerCase() === 'alpha/markdown';

function getClassNames(data, isInputBox) {
  const isSmallFontSize = data.value && data.value.length > 20;
  const isMediumFontSize =
    data.value && data.value.length > 15 && data.value.length < 19;

  return classnames(styles.qrCodeText, {
    [styles.voucherInputBox]: isInputBox,
    [styles.qrCodeTextSmall]: isSmallFontSize,
    [styles.qrCodeTextMedium]: isMediumFontSize
  });
}

const AlphaText = props => {
  const { data } = props;
  const type = data.type;
  const useInputBox = type === 'alpha/url';
  const classNames = useMemo(() => getClassNames(data, useInputBox), [
    data,
    useInputBox
  ]);

  const onInputFocus = useCallback(event => {
    event.target.select();
  }, []);

  return useInputBox ? (
    <input
      type="text"
      value={data.value}
      className={classNames}
      data-test-id="voucher-image-input-code"
      onFocus={onInputFocus}
      readOnly
    />
  ) : isMarkdown(data) ? (
    <div className={styles.voucherMarkdown}>
      <Markdown value={data.value} />
    </div>
  ) : (
    <div data-test-id="voucher-image-text" className={classNames}>
      {data.value}
    </div>
  );
};

AlphaText.propTypes = {
  data: PropTypes.object.isRequired
};

export default AlphaText;
